export default "__VITE_ASSET__CXOzEAUD__"